export default __webpack_public_path__ + "static/media/ImgTicket04.6bf144e5.jpg";